/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './MobileAppFeaturedPromo.scss';

import { Button } from 'sarsaparilla';

import backgroundImageSrc from './images/mobile-app-featured-background.webp';
import foregroundImageSrc from './images/mobile-app-featured-foreground.webp';

export function MobileAppFeaturedPromo() {
    return (
        <div className="nav--mobile-app-featured-promo">
            <div className="image-group">
                <img src={backgroundImageSrc} alt="" className="image" />
            </div>

            <div className="overlay" />
            <div className="overlay-shader" />

            <img src={foregroundImageSrc} alt="" className="foreground-image" />

            <div className="content">
                <h2>Adventure is at Your Fingertips</h2>
                <p>
                    Get outdoors, experience America, and bring home a story with the{' '}
                    {process.env.SITE_NAME} mobile app!
                </p>
                <Button
                    className="learn-more-button"
                    appearance="tertiary-white"
                    aria-label="Learn more about the mobile app"
                    href="/mobile-app"
                    gaReportName="Mobile app featured promo"
                    gaReportCreative="featured promo for mobile app"
                    gaReportPosition="HomePage"
                    shouldReportToGA
                >
                    Learn More
                </Button>
            </div>
        </div>
    );
}
